import * as Collapsible from '@radix-ui/react-collapsible';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { AnimatedNavigationPanelTreeChildren } from './animated-children';

type AnimatedNavigationPanelTreeDisclosureContentProps = Omit<
  ComponentPropsWithoutRef<typeof Collapsible.Content>,
  'children' | 'forceMount'
> & {
  collapsed: boolean;
  children?: ReactNode;
  placeholder?: ReactNode;
};

export const AnimatedNavigationPanelTreeDisclosureContent = ({
  collapsed,
  children,
  placeholder,
  ...contentProps
}: AnimatedNavigationPanelTreeDisclosureContentProps) => {
  return (
    <Collapsible.Content
      {...contentProps}
      forceMount
      aria-hidden={collapsed}
      inert={collapsed ? true : undefined}
    >
      <AnimatedNavigationPanelTreeChildren>
        {collapsed ? null : placeholder}
      </AnimatedNavigationPanelTreeChildren>
      <AnimatedNavigationPanelTreeChildren>
        {collapsed ? null : children}
      </AnimatedNavigationPanelTreeChildren>
    </Collapsible.Content>
  );
};
